

<template>
    <section class="bg-light-1 py-4">
        <div class="container">
            <div class="d-flex align-items-center">
                <h2 class="title-blog text-7">Gift Vouchers</h2>
                <!--                <router-link to="/transaction/check" class="btn btn-primary btn-sm shadow-none ml-auto">-->
                <!--                    Redeem-->
                <!--                </router-link>-->
            </div>
            <hr class="my-4">
            <div v-if="giftCards.loading"
                 class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <div v-if="serviceDisabled(currentActiveMenu)" class="text-center alert alert-danger">
                <strong>NOTE:</strong> {{ currentActiveMenu.disabledMessage || 'The service is unavailable at the moment. Please try again later.' }}
            </div>
            <div v-else class="row">
                <template v-for="giftCard in filteredCards">
                    <div v-if="giftCard.types.length" class="col-lg-3 col-md-4 col-6 px-2"
                         :key="'gift-card' + giftCard.id">
                        <div
                            class="blog-post card shadow-sm border-0 bg-light-3 mb-3">
                            <img class="card-img-top"
                                 :src="giftCard.display.image"
                                 :alt="giftCard.display.name">
                            <div class="card-body px-4">
                                <div class="d-flex align-items-center">
                                    <div class="mr-auto">
                                        <strong class="title-blog text-3 mb-0 text-truncate d-block">
                                            {{ giftCard.name }}
                                        </strong>
                                        <router-link
                                            v-if="giftCard.terms"
                                            :to="`/gift-vouchers/terms/${giftCard.terms.id}`">
                                            Terms & Conditions
                                        </router-link>
                                    </div>

                                    <router-link
                                        :to="`/gift-vouchers/purchase/${giftCard.encoded_id}`"
                                        class="btn btn-outline-primary btn-sm shadow-none">
                                        Buy
                                    </router-link>
                                </div>

                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <!-- Pagination ============================================= -->
            <ul v-if="giftCards.content.last_page > 1" class="pagination justify-content-center my-5">
                <li class="page-item disabled" v-if="giftCards.content.current_page > 1">
                    <a class="page-link" href="#" @click="giftCards.fetchPrevious()" tabindex="-1">
                        <i class="fas fa-angle-left"></i>
                    </a>
                </li>
                <template v-for="page in giftCards.content.last_page">
                    <li class="page-item"
                        v-if="page > giftCards.content.current_page - 3 && page < giftCards.content.current_page + 3"
                        :key="'page' + page"
                        :class="[page === giftCards.content.current_page ? 'active' : '']">
                        <a class="page-link" href="#" @click="giftCards.fetchPage(page)">{{ page }}</a>
                    </li>
                </template>
                <li v-if="giftCards.content.last_page > 6"
                    class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">...
                </li>
                <li class="page-item" v-if="giftCards.content.current_page < giftCards.content.last_page">
                    <a class="page-link" href="#" @click="giftCards.fetchNext()">
                        <i class="fas fa-angle-right"></i>
                    </a>
                </li>
            </ul>
            <!-- Pagination end -->
        </div>
    </section>
</template>
<script>
import {appDataMixin} from "../../../core/data/global";
import {giftCardsMixin} from "../../../core/data/giftcards";
import Carousel from "../../custom/carousel.vue";
import {GiftCardsIndex} from "../../../app/consumer/controllers/gift-cards.index";

export default {
    name: "GiftCards",
    components: {Carousel},
    mixins: [giftCardsMixin, GiftCardsIndex , appDataMixin],
    metaInfo: {
        title: 'Gift Cards'
    },
    computed: {
        menuItem() {
            return this.menu.find(m => this.$route.path.startsWith(m.route)) || {};
        },
        currentMenu() {
            return this.services.find(m => this.$route.path.startsWith(m.route)) || {}
        },
        currentMenuSameProvider() {
            return (this.currentMenu.options || []).every(s => !s.provider || s.provider === this.currentMenu.provider) && this.currentMenu.image
        },
        currentActiveMenu() {
            return this.flatServices[this.$route.fullPath]
        },
        currentTitle() {
            return this.title ||
                (this.currentActiveMenu && this.currentActiveMenu.displayName) ||
                (this.currentActiveMenu && this.currentActiveMenu.name) ||
                this.defaultTitle
        },
        currentSubtitle() {
            return this.subtitle ||
                (this.currentActiveMenu && this.currentActiveMenu.displayName) ||
                (this.currentActiveMenu && this.currentActiveMenu.name) ||
                this.defaultSubtitle
        },
        currentProvider() {
            return (this.currentActiveMenu && this.currentActiveMenu.provider) ||
                (this.currentMenu && this.currentMenu.provider)
        },
        icon() {
            return (this.currentActiveMenu && this.currentActiveMenu.image) ||
                (this.currentActiveMenu && this.currentActiveMenu.icon) ||
                (this.currentMenu && this.currentMenu.image) ||
                (this.currentMenu && this.currentMenu.icon)
        }
    },
    mounted() {

        this.$nextTick(() => {
        })
    }
}
</script>
<style scoped>
.blog-post img {
    height: 160px;
    object-fit: cover;
    border-radius: 12px;
}
</style>
